export const storeIcons = {
  spotify: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 41 40"
      fill="none"
    >
      <path
        d="M20.5 0C9.45394 0 0.5 8.95394 0.5 20C0.5 31.0461 9.45394 40 20.5 40C31.5461 40 40.5 31.0461 40.5 20C40.5 8.95531 31.5461 0.00136473 20.5 0Z"
        fill="#1ED760"
      />
      <path
        d="M29.6718 28.8451C29.3128 29.4346 28.5445 29.6189 27.9577 29.2599C23.2617 26.3899 17.3497 25.7417 10.3882 27.3316C9.71679 27.4858 9.04807 27.0655 8.89522 26.394C8.74101 25.7226 9.15998 25.0539 9.83279 24.901C17.4507 23.161 23.9863 23.9102 29.2582 27.131C29.8451 27.4926 30.032 28.2582 29.6718 28.8451Z"
        fill="black"
      />
      <path
        d="M32.1225 23.4012C31.6707 24.1354 30.71 24.3647 29.9771 23.9143C24.6028 20.6103 16.4063 19.6536 10.0481 21.5834C9.22379 21.8331 8.3531 21.3677 8.10199 20.5448C7.85361 19.7205 8.31898 18.8512 9.14191 18.6001C16.405 16.3961 25.4353 17.4633 31.608 21.2572C32.3422 21.7089 32.5742 22.6683 32.1225 23.4012Z"
        fill="black"
      />
      <path
        d="M32.3304 17.729C25.8835 13.901 15.2496 13.5489 9.09466 15.4158C8.1066 15.7161 7.06122 15.1579 6.76235 14.1698C6.46347 13.1818 7.02028 12.1364 8.0097 11.8362C15.0749 9.69217 26.8183 10.1057 34.2397 14.511C35.1281 15.0392 35.4201 16.1869 34.8934 17.074C34.3679 17.9638 33.2175 18.2572 32.3304 17.729Z"
        fill="black"
      />
    </svg>
  ),
  appleMusic: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 40 40"
      fill="none"
    >
      <rect x="6.7207" y="2.50488" width="26.6667" height="35" fill="white" />
      <path
        d="M39.9827 10.2075C39.9826 8.97753 39.8787 7.75247 39.5848 6.55498C39.0572 4.37371 37.8134 2.70744 35.9521 1.48388C34.9945 0.858911 33.9407 0.475219 32.8208 0.272842C31.9608 0.116628 31.0896 0.0453979 30.2171 0.0254823C30.1521 0.0192758 30.0809 0.00550724 30.0084 -0.000698688L9.97023 0.000908936C9.71645 0.0209149 9.46276 0.0334481 9.20898 0.0459819C7.96529 0.117292 6.72907 0.247387 5.55671 0.716242C3.33055 1.59525 1.72201 3.13166 0.784666 5.34554C0.459735 6.09431 0.296042 6.88816 0.179885 7.6957C0.0824395 8.34695 0.0300086 9.0045 0.0113361 9.66195C0.0113403 9.71444 -0.00116977 9.76575 -0.00116556 9.81824L0.000468833 30.1901C0.0130012 30.4251 0.0267949 30.6589 0.0392372 30.8939C0.12442 32.2552 0.299447 33.6027 0.873278 34.8527C1.95476 37.2164 3.77105 38.7713 6.26481 39.5199C6.96099 39.7349 7.69102 39.8323 8.41978 39.8972C9.3447 39.9884 10.2685 40.0009 11.1934 40.0008L29.5779 39.9993C30.4503 39.9993 31.3227 39.9404 32.1953 39.8303C33.5689 39.6539 34.8576 39.2501 36.0237 38.4825C37.4236 37.5573 38.4785 36.3335 39.1546 34.8034C39.467 34.0996 39.6432 33.3521 39.7732 32.5957C39.9619 31.4694 40.0005 30.3294 40.0004 29.1906C39.9937 22.8617 39.9994 16.534 39.9927 10.205L39.9827 10.2075ZM29.2797 16.8549L29.2805 26.3739C29.2806 27.0702 29.1831 27.754 28.8707 28.3852C28.3895 29.3678 27.6083 29.9866 26.5596 30.2868C25.9797 30.4555 25.3809 30.5468 24.776 30.5732C23.1935 30.652 21.8197 29.5771 21.5396 28.0146C21.2983 26.7258 21.9169 25.3057 23.2706 24.6418C23.8043 24.3818 24.3842 24.2254 24.963 24.1079C25.5941 23.9717 26.2254 23.8478 26.8503 23.704C27.3129 23.6003 27.6116 23.3202 27.7028 22.8439C27.729 22.7402 27.7353 22.6289 27.7353 22.5251C27.735 19.4976 27.7348 16.47 27.7345 13.4499C27.7345 13.3461 27.7145 13.2411 27.6895 13.1436C27.6245 12.8898 27.442 12.7399 27.182 12.7524C26.9144 12.7649 26.6545 12.8111 26.3945 12.8637C25.1246 13.1113 23.8559 13.3652 22.5922 13.6253L16.4275 14.8696C16.4012 14.8758 16.3687 14.8896 16.3425 14.8896C15.88 15.0196 15.7175 15.2284 15.6975 15.7097C15.6913 15.7809 15.6976 15.8534 15.6976 15.9246C15.6917 20.2611 15.6983 24.5974 15.6924 28.9326C15.6924 29.6364 15.6137 30.3263 15.3351 30.9764C14.8727 32.044 14.0527 32.7153 12.9465 33.0342C12.3604 33.203 11.7616 33.3018 11.1491 33.3206C9.5542 33.3795 8.22534 32.3183 7.9528 30.7495C7.71763 29.3958 8.33626 27.9369 9.8724 27.2855C10.4711 27.038 11.0899 26.9016 11.7211 26.7716C12.1961 26.674 12.6785 26.5765 13.1535 26.479C13.7909 26.3426 14.1235 25.9388 14.1559 25.2876L14.1559 25.0401C14.1555 20.1049 14.1551 15.1697 14.1547 10.2346C14.1547 10.0259 14.1809 9.81836 14.2259 9.6158C14.3433 9.14082 14.682 8.86702 15.137 8.75571C15.5608 8.64441 15.997 8.56696 16.4257 8.47564C17.6494 8.22806 18.8669 7.98039 20.0905 7.73902L23.8728 6.97C24.9928 6.74862 26.1052 6.52104 27.2252 6.29967C27.5902 6.22843 27.9615 6.14963 28.3314 6.12331C28.8451 6.07835 29.2039 6.40331 29.2564 6.92455C29.269 7.04833 29.2764 7.17203 29.2764 7.29581L29.2772 16.8474L29.2797 16.8549Z"
        fill="url(#paint0_linear_1436_7773)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1436_7773"
          x1="19.998"
          y1="0.000104423"
          x2="20.0013"
          y2="40.0001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FB5971" />
          <stop offset="1" stop-color="#FA253D" />
        </linearGradient>
      </defs>
    </svg>
  ),
  youtubeMusic: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 41 40"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.0995 20C40.0995 25.5229 38.1468 30.2368 34.2416 34.1421C30.3364 38.0473 25.6224 40 20.0995 40C14.5768 40 9.8627 38.0473 5.95744 34.1421C2.05231 30.2368 0.0996094 25.5229 0.0996094 20C0.0996094 14.4771 2.05231 9.76318 5.95744 5.85794C9.86285 1.95255 14.5768 0 20.0997 0C25.6226 0 30.3365 1.9527 34.2418 5.85794C38.147 9.76318 40.0996 14.4771 40.0996 20H40.0995Z"
        fill="#FF0000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.0995 20C32.0995 23.3137 30.9279 26.1421 28.5848 28.4852C26.2417 30.8284 23.4133 31.9999 20.0996 31.9999C16.7858 31.9999 13.9574 30.8284 11.6143 28.4852C9.27123 26.1421 8.09961 23.3137 8.09961 20C8.09961 16.6863 9.27123 13.8578 11.6143 11.5148C13.9574 9.17159 16.7859 8 20.0996 8C23.4133 8 26.2417 9.17159 28.5848 11.5148C30.9279 13.8578 32.0995 16.6863 32.0995 20Z"
        fill="#FF0000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M32.0995 20C32.0995 23.3137 30.9279 26.1421 28.5848 28.4852C26.2417 30.8284 23.4133 31.9999 20.0996 31.9999C16.7858 31.9999 13.9574 30.8284 11.6143 28.4852C9.27123 26.1421 8.09961 23.3137 8.09961 20C8.09961 16.6863 9.27123 13.8578 11.6143 11.5148C13.9574 9.17159 16.7859 8 20.0996 8C23.4133 8 26.2417 9.17159 28.5848 11.5148C30.9279 13.8578 32.0995 16.6863 32.0995 20Z"
        stroke="white"
        stroke-width="2.65902"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.0996 25.9082L26.4888 20.0016L16.0996 14.0916V25.9082Z"
        fill="white"
      />
    </svg>
  ),
  deezer: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 41 40"
      fill="none"
    >
      <g clip-path="url(#clip0_1437_10713)">
        <path
          d="M0.300781 18.6697H7.74279M0.300781 21.693H7.74279"
          stroke="#F1796E"
          stroke-width="2.32563"
        />
        <path
          d="M7.74279 30.7629H0.300781M7.74279 27.7396H0.300781M7.74279 24.7163H0.300781"
          stroke="#EC2529"
          stroke-width="2.32563"
        />
        <path
          d="M8.44141 24.7163H15.8834M8.44141 27.7396H15.8834M8.44141 30.7629H15.8834"
          stroke="#F6DD05"
          stroke-width="2.32563"
        />
        <path
          d="M16.5801 18.6699H24.0221M16.5801 21.6932H24.0221M16.5801 15.6466H24.0221M16.5801 12.6233H24.0221"
          stroke="#E78DCC"
          stroke-width="2.32563"
        />
        <path
          d="M16.5801 24.7163H24.0221M16.5801 27.7396H24.0221M16.5801 30.7629H24.0221"
          stroke="#D81996"
          stroke-width="2.32563"
        />
        <path
          d="M24.7188 18.6697H32.1608M24.7188 21.693H32.1608"
          stroke="#D6E465"
          stroke-width="2.32563"
        />
        <path
          d="M24.7188 24.7163H32.1608M24.7188 27.7396H32.1608M24.7188 30.7629H32.1608"
          stroke="#ADDA1A"
          stroke-width="2.32563"
        />
        <path
          d="M32.8574 18.67H40.2994M32.8574 21.6934H40.2994M32.8574 15.6467H40.2994M32.8574 12.6234H40.2994M32.8574 9.6001H40.2994"
          stroke="#B0D8E6"
          stroke-width="2.32563"
        />
        <path
          d="M32.8574 24.7163H40.2994M32.8574 27.7396H40.2994M32.8574 30.7629H40.2994"
          stroke="#56BBE9"
          stroke-width="2.32563"
        />
      </g>
      <defs>
        <clipPath id="clip0_1437_10713">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0.300781)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  tidal: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 41 28"
      fill="none"
    >
      <path
        d="M20.3013 13.999L26.968 20.6659L20.3013 27.3331L13.6344 20.6659L20.3013 13.999ZM6.96745 0.667016L13.6344 7.33234L6.96745 13.9995L0.300781 7.33234L6.96745 0.667016ZM33.6344 0.667016L40.3008 7.33234L33.6344 13.9995L26.9673 7.33248L20.3013 13.999L13.6344 7.33181L20.3013 0.666748L26.968 7.33181L33.6344 0.667016Z"
        fill="white"
      />
    </svg>
  ),
  audiomack: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={"100%"}
      height={"100%"}
      viewBox="0 0 24 24"
      id="audiomack"
    >
      <g fill="#EF815F" fill-rule="evenodd">
        <path d="M20.1227 5.50473c.2473.03428.4313.24566.4313.49526v8.40581l1.2876-.43c.2619-.0875.5451.0539.6326.3158.0875.2619-.0539.5451-.3158.6326l-1.9459.65c-.1525.051-.3202.0255-.4507-.0685-.1304-.094-.2078-.2449-.2078-.4057v-5.49391l-2.6945 9.52991c-.0679.2402-.3026.3935-.5498.3593-.2472-.0343-.4313-.2457-.4313-.4953v-7.4213l-2.5181 4.7312c-.0922.1732-.2771.2764-.4728.2641-.1958-.0123-.3663-.138-.436-.3213l-1.3175-3.4657-1.22446 2.5308c-.08695.1797-.27247.2904-.47192.2817-.19945-.0087-.37459-.1352-.44554-.3218l-.59841-1.5741-.63822.604c-.16958.1605-.42765.1822-.62171.0524l-1.41176-.9444c-.22952-.1536-.29111-.4641-.13757-.6936.15354-.2295.46408-.2911.6936-.1376l1.07998.7225.89291-.8451c.1214-.1149.2922-.1615.45515-.1242.16295.0372.2965.1535.3559.3097l.45265 1.1907 1.2245-2.5308c.0869-.1797.2725-.2904.4719-.2817.1995.0087.3746.1352.4455.3218l1.3384 3.5206 2.9421-5.52782c.1078-.2026.3397-.30578.5624-.25021.2227.05557.379.25561.379.48512v5.81891l2.6945-9.52994c.0679-.2402.3026-.39351.5498-.35923zM2.5 13c0-.2761.22386-.5.5-.5h.5c.27614 0 .5.2239.5.5 0 .2761-.22386.5-.5.5h-.5c-.27614 0-.5-.2239-.5-.5z"></path>
      </g>
    </svg>
  ),
  iHeartRadio: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      aria-label="iHeartRadio"
      viewBox="0 0 512 512"
      width={"100%"}
      height={"100%"}
      id="iheartradio"
    >
      <rect width="512" height="512" fill="transparent" rx="15%"></rect>
      <path
        id="a"
        fill="#c6002b"
        d="M147.4 301.3c-32.3 -28.6 -48.6 -58.4 -48.6 -86.7 0 -28.3 15.9 -57.9 36.9 -71.1 10.3 -4.4 14.6 8.2 8 12.6 -16.7 10.5 -29.9 35.1 -29.9 58.7 0 23.6 14.7 49.6 43.6 75.2 7 8.7 -3.8 16.5 -9.9 11.2zm48.5 -25.5c-21.9 -12.3 -36.6 -36.3 -36.6 -59.4 0 -23.1 12.5 -43.7 32.3 -54 10.5 -3.7 14 9.3 7 13.2 -15 7.8 -24.3 23.3 -24.3 40.2 0.1 18.4 11.7 37.2 29 46.9 8.7 7.1 -0.6 16.7 -7.4 13.2zM256 253.9c-17.9 0 -32.5 -14.5 -32.5 -32.4 0 -17.9 14.6 -32.5 32.5 -32.5v-30.7c-19.4 -28.9 -52.8 -48.8 -90.3 -48.8 -59.6 0 -107.9 48.3 -107.9 107.9 0 37.8 24 65.1 49 90.3l97.9 92.6c6.3 3.9 13.5 1.3 13.6 -5.8v-72.1c0 -20.9 16.9 -37.8 37.8 -37.8z"
      ></path>
      <use xlinkHref="#a" transform="matrix(-1 0 0 1 510 0)"></use>
    </svg>
  ),
  amazonMusic: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 41 40"
      fill="none"
    >
      <path
        d="M27.093 18.4876C26.8234 18.6605 26.419 18.7901 25.9247 18.7901C25.1608 18.7901 24.4418 18.7037 23.7228 18.4876C23.5431 18.4444 23.4083 18.4012 23.3184 18.4012C23.1836 18.4012 23.1387 18.4876 23.1387 18.6605V19.0925C23.1387 19.2221 23.1836 19.3086 23.2285 19.395C23.2735 19.4382 23.3633 19.5246 23.4982 19.5678C24.2171 19.8703 25.026 19.9999 25.9247 19.9999C26.8683 19.9999 27.5873 19.7838 28.1714 19.3518C28.7556 18.9197 29.0252 18.358 29.0252 17.6235C29.0252 17.105 28.8904 16.7161 28.6208 16.3705C28.3512 16.068 27.9018 15.7656 27.2727 15.5495L26.0145 15.0743C25.5202 14.9014 25.1608 14.7286 25.026 14.5558C24.8462 14.3829 24.7563 14.2101 24.7563 13.9077C24.7563 13.2596 25.2506 12.9139 26.2841 12.9139C26.8683 12.9139 27.4525 13.0003 27.9917 13.1731C28.1714 13.2164 28.3062 13.2596 28.3512 13.2596C28.486 13.2596 28.5759 13.1731 28.5759 13.0003V12.5682C28.5759 12.4386 28.5309 12.3522 28.486 12.2658C28.441 12.1794 28.3512 12.1362 28.2164 12.093C27.5423 11.8769 26.8683 11.7473 26.1943 11.7473C25.3405 11.7473 24.6215 11.9633 24.0823 12.3522C23.5431 12.7411 23.2735 13.3028 23.2735 13.9509C23.2735 14.9446 23.8576 15.6792 25.026 16.1112L26.374 16.5865C26.8234 16.7593 27.093 16.889 27.2727 17.0618C27.4525 17.2346 27.4974 17.4074 27.4974 17.6667C27.4974 18.0123 27.3626 18.3148 27.093 18.4876Z"
        fill="url(#paint0_linear_1585_7949)"
      />
      <path
        d="M20.0387 12.2661V18.0126C19.2748 18.4879 18.5109 18.7471 17.747 18.7471C17.2527 18.7471 16.8932 18.6175 16.6685 18.3583C16.4439 18.099 16.354 17.7102 16.354 17.1485V12.2661C16.354 12.05 16.2641 11.9636 16.0394 11.9636H15.0958C14.8711 11.9636 14.7812 12.05 14.7812 12.2661V17.6238C14.7812 18.3583 14.961 18.9632 15.3654 19.352C15.7698 19.7409 16.354 19.9569 17.1179 19.9569C18.1514 19.9569 19.1849 19.6113 20.1735 18.92L20.2634 19.4385C20.2634 19.5681 20.3083 19.6113 20.3982 19.6545C20.4431 19.6977 20.533 19.6977 20.6678 19.6977H21.3418C21.5665 19.6977 21.6564 19.6113 21.6564 19.3952V12.2661C21.6564 12.05 21.5665 11.9636 21.3418 11.9636H20.3982C20.1286 11.9636 20.0387 12.0932 20.0387 12.2661Z"
        fill="url(#paint1_linear_1585_7949)"
      />
      <path
        d="M11.5013 19.7406H12.4449C12.6696 19.7406 12.7594 19.6542 12.7594 19.4382V14.0373C12.7594 13.3028 12.5797 12.7411 12.1753 12.3522C11.7709 11.9633 11.2316 11.7473 10.4677 11.7473C9.43422 11.7473 8.35577 12.093 7.32226 12.8275C6.96278 12.093 6.28874 11.7473 5.30017 11.7473C4.31159 11.7473 3.32301 12.093 2.33443 12.7411L2.24456 12.2658C2.24456 12.1362 2.19962 12.093 2.10975 12.0498C2.06482 12.0066 1.97495 12.0066 1.88508 12.0066H1.16611C0.941433 12.0066 0.851562 12.093 0.851562 12.309V19.4814C0.851562 19.6974 0.941433 19.7838 1.16611 19.7838H2.10975C2.33443 19.7838 2.4243 19.6974 2.4243 19.4814V13.6484C3.1882 13.2164 3.9521 12.9571 4.76094 12.9571C5.2103 12.9571 5.52484 13.0867 5.70459 13.346C5.88433 13.6052 6.01913 13.9509 6.01913 14.4694V19.4382C6.01913 19.6542 6.109 19.7406 6.33368 19.7406H7.27732C7.502 19.7406 7.59187 19.6542 7.59187 19.4382V14.1237V13.8645C7.59187 13.778 7.59187 13.6916 7.59187 13.6484C8.40071 13.1731 9.16461 12.9571 9.92851 12.9571C10.3779 12.9571 10.6924 13.0867 10.8722 13.346C11.0519 13.6052 11.1867 13.9509 11.1867 14.4694V19.4382C11.1867 19.6542 11.2766 19.7406 11.5013 19.7406Z"
        fill="url(#paint2_linear_1585_7949)"
      />
      <path
        d="M35.9914 25.4873C31.0934 27.4748 25.7461 28.4685 20.8931 28.4685C13.7034 28.4685 6.73845 26.5674 1.12153 23.4133C1.03166 23.3701 0.941786 23.3269 0.851915 23.3269C0.537367 23.3269 0.357625 23.6726 0.672173 23.975C5.88468 28.5118 12.8047 31.2338 20.4437 31.2338C25.9259 31.2338 32.2618 29.5919 36.6205 26.481C37.3844 25.9625 36.7553 25.1848 35.9914 25.4873Z"
        fill="url(#paint3_linear_1585_7949)"
      />
      <path
        d="M35.8561 13.6916C36.2606 13.2596 36.8897 13.0435 37.7884 13.0435C38.2377 13.0435 38.6871 13.0867 39.0915 13.2164C39.2263 13.2596 39.2712 13.2596 39.3611 13.2596C39.4959 13.2596 39.5858 13.1732 39.5858 12.9571V12.525C39.5858 12.3954 39.5408 12.2658 39.4959 12.2226C39.451 12.1794 39.3611 12.093 39.2712 12.0498C38.6871 11.9201 38.1029 11.7905 37.5637 11.7905C36.3055 11.7905 35.3619 12.1362 34.6429 12.8707C33.9689 13.562 33.6094 14.599 33.6094 15.8952C33.6094 17.1914 33.9239 18.1852 34.598 18.8765C35.272 19.5678 36.2156 19.9135 37.4738 19.9135C38.1479 19.9135 38.7769 19.827 39.2712 19.611C39.406 19.5678 39.4959 19.5246 39.5408 19.4382C39.5858 19.395 39.5858 19.2654 39.5858 19.1357V18.7037C39.5858 18.4876 39.4959 18.4012 39.3611 18.4012C39.3162 18.4012 39.2263 18.4012 39.1364 18.4444C38.6421 18.574 38.1479 18.6605 37.6985 18.6605C36.8447 18.6605 36.2156 18.4444 35.8112 18.0124C35.4068 17.5803 35.2271 16.889 35.2271 15.9816V15.7656C35.272 14.815 35.4517 14.1237 35.8561 13.6916Z"
        fill="url(#paint4_linear_1585_7949)"
      />
      <path
        d="M37.8787 29.5489C40.2154 27.6478 40.8445 23.7159 40.3502 23.111C40.1255 22.8518 39.047 22.5925 37.699 22.5925C36.261 22.5925 34.5535 22.895 33.2504 23.7591C32.846 24.0184 32.9358 24.364 33.3402 24.3208C34.7332 24.148 37.8787 23.8023 38.4629 24.4936C39.0021 25.185 37.8338 28.0366 37.2946 29.2896C37.1598 29.6785 37.4743 29.8081 37.8787 29.5489Z"
        fill="url(#paint5_linear_1585_7949)"
      />
      <path
        d="M31.6312 11.9636H30.6876C30.4629 11.9636 30.373 12.05 30.373 12.2661V19.4385C30.373 19.6545 30.4629 19.7409 30.6876 19.7409H31.6312C31.8559 19.7409 31.9458 19.6545 31.9458 19.4385V12.2661C31.9458 12.0932 31.8559 11.9636 31.6312 11.9636Z"
        fill="url(#paint6_linear_1585_7949)"
      />
      <path
        d="M31.9029 9.02536C31.7231 8.85253 31.4535 8.76611 31.139 8.76611C30.8244 8.76611 30.5997 8.85253 30.42 9.02536C30.2403 9.19818 30.1504 9.41422 30.1504 9.67346C30.1504 9.93271 30.2403 10.1919 30.42 10.3216C30.5997 10.4944 30.8244 10.5808 31.139 10.5808C31.4535 10.5808 31.6782 10.4944 31.8579 10.3216C32.0377 10.1487 32.1275 9.93271 32.1275 9.67346C32.1275 9.41422 32.0826 9.15498 31.9029 9.02536Z"
        fill="url(#paint7_linear_1585_7949)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1585_7949"
          x1="9.13384"
          y1="32.1364"
          x2="33.6514"
          y2="6.63815"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C6CB3" />
          <stop offset="0.2911" stop-color="#1E84C4" />
          <stop offset="0.8873" stop-color="#4CC0EF" />
          <stop offset="1" stop-color="#4CC0EF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1585_7949"
          x1="5.19273"
          y1="28.3466"
          x2="29.7103"
          y2="2.84835"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C6CB3" />
          <stop offset="0.2911" stop-color="#1E84C4" />
          <stop offset="0.8873" stop-color="#4CC0EF" />
          <stop offset="1" stop-color="#4CC0EF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1585_7949"
          x1="-0.498294"
          y1="22.8739"
          x2="24.0192"
          y2="-2.62433"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C6CB3" />
          <stop offset="0.2911" stop-color="#1E84C4" />
          <stop offset="0.8873" stop-color="#4CC0EF" />
          <stop offset="1" stop-color="#4CC0EF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1585_7949"
          x1="10.1495"
          y1="33.1119"
          x2="34.667"
          y2="7.61366"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C6CB3" />
          <stop offset="0.2911" stop-color="#1E84C4" />
          <stop offset="0.8873" stop-color="#4CC0EF" />
          <stop offset="1" stop-color="#4CC0EF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1585_7949"
          x1="14.8022"
          y1="37.586"
          x2="39.3197"
          y2="12.0877"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C6CB3" />
          <stop offset="0.2911" stop-color="#1E84C4" />
          <stop offset="0.8873" stop-color="#4CC0EF" />
          <stop offset="1" stop-color="#4CC0EF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1585_7949"
          x1="19.4885"
          y1="42.0918"
          x2="44.006"
          y2="16.5936"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C6CB3" />
          <stop offset="0.2911" stop-color="#1E84C4" />
          <stop offset="0.8873" stop-color="#4CC0EF" />
          <stop offset="1" stop-color="#4CC0EF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1585_7949"
          x1="11.6769"
          y1="34.5821"
          x2="36.1944"
          y2="9.08388"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C6CB3" />
          <stop offset="0.2911" stop-color="#1E84C4" />
          <stop offset="0.8873" stop-color="#4CC0EF" />
          <stop offset="1" stop-color="#4CC0EF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1585_7949"
          x1="8.46464"
          y1="31.4913"
          x2="32.9822"
          y2="5.99306"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0C6CB3" />
          <stop offset="0.2911" stop-color="#1E84C4" />
          <stop offset="0.8873" stop-color="#4CC0EF" />
          <stop offset="1" stop-color="#4CC0EF" />
        </linearGradient>
      </defs>
    </svg>
  ),
  iTunes: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 41 40"
      fill="none"
    >
      <g clip-path="url(#clip0_1437_10707)">
        <path
          d="M9.42312 35.679C0.763637 29.4483 -1.20772 17.3776 5.01987 8.71816C11.2471 0.0589286 23.3159 -1.90995 31.9756 4.3208C40.6351 10.5513 42.6065 22.622 36.3793 31.2817C30.1516 39.9409 18.0832 41.9098 9.42312 35.679Z"
          stroke="url(#paint0_linear_1437_10707)"
          stroke-width="1.36488"
          stroke-miterlimit="10"
        />
        <path
          d="M27.5779 29.2046C28.8009 28.8474 29.6644 27.9812 30.0177 26.7576L30.122 26.398L30.1357 16.7515C30.1458 9.52743 30.1361 7.0601 30.0958 6.92543C30.0534 6.78266 29.9861 6.66292 29.8981 6.56829C29.7686 6.48885 29.613 6.44699 29.4367 6.44727C29.3151 6.44727 28.8929 6.50559 28.499 6.57693C26.7566 6.89285 16.4859 8.9298 16.3105 8.9944C16.0391 9.09431 15.7703 9.33171 15.6427 9.58366L15.5346 9.79713C15.5346 9.79713 15.4835 24.9173 15.4049 25.0875C15.2853 25.3465 15.0196 25.5919 14.7747 25.6701C14.6587 25.7073 14.2001 25.8098 13.7549 25.8979C11.6942 26.3062 10.9289 26.6004 10.2815 27.2333C9.91378 27.5927 9.64148 28.0833 9.52378 28.598C9.41121 29.0901 9.44885 29.8264 9.60922 30.2742C9.77726 30.7424 10.0477 31.1424 10.4014 31.457C10.7228 31.7037 11.1023 31.8873 11.529 31.9963C12.4722 32.2368 14.2383 31.9693 15.1411 31.4493C15.5186 31.2317 16.0043 30.7757 16.2569 30.4005C16.357 30.2519 16.5072 29.9531 16.5914 29.7359C16.8854 28.9754 16.8947 15.4301 16.9322 15.2595C16.996 14.9699 17.1948 14.758 17.4686 14.686C17.7154 14.6215 27.605 12.6745 27.8834 12.6356C28.1283 12.6018 28.3595 12.6803 28.4858 12.8352C28.5607 12.8752 28.624 12.9292 28.6683 12.9956C28.7486 13.1147 28.7534 13.3502 28.7654 17.6387C28.7791 22.5747 28.7852 22.459 28.5158 22.7706C28.3197 22.997 28.0751 23.0848 27.0699 23.289C25.5405 23.6 25.0172 23.7476 24.4314 24.0322C23.7001 24.388 23.294 24.7778 22.9801 25.4251C22.7581 25.883 22.6752 26.2262 22.6759 26.6819C22.6772 27.4971 22.9596 28.1338 23.5965 28.7572C23.6553 28.8146 23.7128 28.868 23.7709 28.9182C24.0918 29.1653 24.419 29.3142 24.8304 29.4086C25.4508 29.5508 26.7136 29.4572 27.5779 29.2046Z"
          fill="url(#paint1_linear_1437_10707)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1437_10707"
          x1="8.10735"
          y1="4.45317"
          x2="33.1625"
          y2="35.646"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF5E4E" />
          <stop offset="0.1505" stop-color="#FF5C6D" />
          <stop offset="0.1694" stop-color="#FF5E73" />
          <stop offset="0.2476" stop-color="#FF6385" />
          <stop offset="0.3026" stop-color="#FF658C" />
          <stop offset="0.3685" stop-color="#E4729F" />
          <stop offset="0.4329" stop-color="#D17CAD" />
          <stop offset="0.4772" stop-color="#CA7FB2" />
          <stop offset="0.5528" stop-color="#9D6CFF" />
          <stop offset="0.5934" stop-color="#9870FF" stop-opacity="0.9882" />
          <stop offset="0.6432" stop-color="#897AFE" stop-opacity="0.9725" />
          <stop offset="0.6979" stop-color="#708CFE" stop-opacity="0.9529" />
          <stop offset="0.7556" stop-color="#4DA4FD" stop-opacity="0.9333" />
          <stop offset="0.8022" stop-color="#2CBCFC" stop-opacity="0.9176" />
          <stop offset="1" stop-color="#00C7FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1437_10707"
          x1="9.12034"
          y1="4.7771"
          x2="32.3334"
          y2="35.0335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF5E4E" />
          <stop offset="0.249" stop-color="#FF5C6D" />
          <stop offset="0.3765" stop-color="#FF658C" />
          <stop offset="0.497" stop-color="#CA7FB2" />
          <stop offset="0.6267" stop-color="#9D6CFF" />
          <stop offset="0.7628" stop-color="#2CBCFC" stop-opacity="0.9176" />
          <stop offset="1" stop-color="#00C7FF" />
        </linearGradient>
        <clipPath id="clip0_1437_10707">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0.699219)"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  vevo: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 41 12"
      fill="none"
    >
      <path
        d="M25.1506 10.9549L19.5838 1.25488H22.8615L25.1506 5.66398L27.44 1.25488H30.7176L25.1506 10.9549ZM5.6666 10.9549L0.0996094 1.25488H3.37741L5.6666 5.66398L7.95595 1.25488H11.2336L5.6666 10.9549ZM15.4086 3.31246C16.3807 3.31246 17.1339 3.98203 17.3648 4.99212H13.4488C13.7101 3.942 14.4061 3.31246 15.4086 3.31246ZM20.2796 5.99991C20.2796 3.217 18.0989 0.960938 15.4086 0.960938C12.7185 0.960938 10.5376 3.217 10.5376 5.99991C10.5376 8.78283 12.721 11.0389 15.4926 11.0389C17.7065 11.0389 19.4428 9.70074 20.0203 7.84754H17.0883C16.6817 8.44936 16.0836 8.60339 15.4926 8.60339C14.3595 8.60339 13.6374 7.82343 13.4109 6.75576H20.225C20.2609 6.50922 20.2796 6.25678 20.2796 5.99991ZM35.0606 8.35144C33.8009 8.35144 32.8771 7.34364 32.8771 5.99991C32.8771 4.65619 33.8017 3.64839 35.0606 3.64839C36.3204 3.64839 37.2442 4.65635 37.2442 5.99991C37.2442 7.34364 36.3204 8.35144 35.0606 8.35144ZM35.0606 0.960938C32.2777 0.960938 30.0217 3.217 30.0217 5.99991C30.0217 8.78283 32.2777 11.0389 35.0606 11.0389C37.8437 11.0389 40.0996 8.78283 40.0996 5.99991C40.0996 3.217 37.8437 0.960938 35.0606 0.960938Z"
        fill="white"
      />
    </svg>
  )
};

export type StoreIconName =
  | "spotify"
  | "appleMusic"
  | "youtubeMusic"
  | "deezer"
  | "tidal"
  | "audiomack"
  | "iHeartRadio"
  | "amazonMusic"
  | "iTunes"
  | "vevo";
